/**
 * Empty component.
 */
function Noop(): null {
  return null
}

export { Noop }
